import React, { FC, useState, useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import {
  GetUserLeaderboardsQuery,
  LeaderboardConfigFragment,
  useGetUserLeaderboardsQuery,
} from 'api';
import { EmptyState, Layouts } from 'components';
import { useNotify } from 'hooks';

import LeaderboardSelect from '../components/Select';
import Leaderboard from '../components/Leaderboard';
import SidebarLoader from '../components/SidebarLoader';
import LeaderboardLoader from '../components/Loader';

interface IMatchParams {
  leaderboard_id: string;
}

const LeaderboardIndex: FC = () => {
  const notify = useNotify();
  const history = useHistory();
  const match = useRouteMatch<IMatchParams>();
  const [currentConfig, setCurrentConfig] = useState<LeaderboardConfigFragment>(null);

  const { params } = match;
  const { data, isLoading } = useGetUserLeaderboardsQuery(null, {
    onError: notify.queryError,
    onSuccess: handleCompleted,
  });

  const leaderboardConfigs = data?.getLeaderboardForUser?.leaderboard_configs ?? [];

  useEffect(() => {
    if (match.params.leaderboard_id) {
      const paramConfig = leaderboardConfigs.find(conf => conf.id === params.leaderboard_id);
      setCurrentConfig(paramConfig);
    }
  }, [match.params]);

  function handleCompleted({ getLeaderboardForUser }: GetUserLeaderboardsQuery) {
    const { leaderboard_configs } = getLeaderboardForUser;

    if (!leaderboard_configs.length) {
      return;
    }

    const paramConfig = leaderboard_configs.find(conf => conf.id === params.leaderboard_id);
    const [firstConfig] = leaderboard_configs;
    const config = paramConfig || firstConfig;

    setCurrentConfig(config);
    history.replace(`/leaderboard/${config.id}`);
  }

  if (isLoading) {
    return (
      <Layouts.App2Column
        desktopSplit="3/9"
        sidebar={<SidebarLoader />}
        main={<LeaderboardLoader />}
      />
    );
  }

  if (!leaderboardConfigs.length) {
    return <Layouts.App1Column main={<EmptyState name="leaderboard" />} />;
  }

  if (!currentConfig) {
    return (
      <Layouts.App2Column
        desktopSplit="3/9"
        sidebar={<LeaderboardSelect configs={leaderboardConfigs} />}
        main={<LeaderboardLoader />}
      />
    );
  }

  return (
    <Layouts.App2Column
      desktopSplit="3/9"
      sidebar={<LeaderboardSelect configs={leaderboardConfigs} />}
      main={<Leaderboard config={currentConfig} />}
    />
  );
};

export default LeaderboardIndex;
